<template>
    <div v-if="isLoaded">
        <div class="content-body" v-bind:class="{ fullscreen_expand: isFullscreen }">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card" style="">
                        <div class="card-header">
                            <v-tour name="blogisticTour" :steps="steps" :callbacks="callbacksTour"></v-tour>
                            <h4 class="card-title">Integração Synchro</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3" @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
                            <div class="heading-elements"  v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                                <ul class="list-inline mb-0">
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Expande a tela" v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Minimiza a tela" v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                    <li><a @click="onFilterShowHide()" v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="table-responsive" style="min-height:370px">
                                <b-row no-gutters>
                                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                                                <multiselect v-model="form.unidade"
                                                :options="optionsUnidade"
                                                track-by="value"
                                                label="label"
                                                :limit="10"
                                                :clear-on-select="false"
                                                :hide-selected="true"
                                                placeholder="Unidade"
                                                tag-placeholder="Selecionar"
                                                select-label="Selecionar"
                                                selected-label="Selecionado"
                                                deselect-label="Remover"
                                                ></multiselect>
                                    </b-col>

                                    <b-col sm="6" md="1" class="p-a-0 m-t-5px">
                                        <div class="fl-flex-label fl-collapsed fl-background">
                                            <input type="text" class="form-control" v-model="form.num_fiscal">
                                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Nº Fiscal</label>
                                        </div>
                                    </b-col>

                                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                                        <div class="fl-flex-label fl-collapsed fl-background">
                                            <input type="text" class="form-control" v-model="form.chave">
                                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Chave</label>
                                        </div>
                                    </b-col>

                                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                                        <b-form-datepicker
                                        locale="pt-br" 
                                        reset-button
                                        placeholder="Data Inicial" 
                                        v-model="dt_inicio" 
                                        class="form-control" 
                                        :date-format-options="{day: 'numeric', month: 'numeric', year: 'numeric' }">
                                        </b-form-datepicker>
                                    </b-col>
                                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                                        <b-form-datepicker
                                        locale="pt-br" 
                                        reset-button
                                        placeholder="Data Fim" 
                                        v-model="dt_fim" 
                                        class="form-control" 
                                        :date-format-options="{day: 'numeric', month: 'numeric', year: 'numeric' }">
                                        </b-form-datepicker>
                                    </b-col>

                                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                                                <multiselect v-model="form.b_modal"
                                                :options="optionsBModal"
                                                track-by="value"
                                                label="label"
                                                :hide-selected="true"
                                                placeholder="Modal"
                                                tag-placeholder="Selecionar"
                                                select-label="Selecionar"
                                                selected-label="Selecionado"
                                                deselect-label="Remover"
                                                ></multiselect>
                                    </b-col>

                                    <b-col sm="6" md="1" class="p-a-0 m-t-5px text-right">
                                        <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                                        <b-btn @click="doGerar(1)" variant="secondary" :disabled="isDisabled">
                                          Gerar
                                        </b-btn>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import accounting from 'accounting'

export default {
    mounted() {
        this.getUnidade();
        this.getBModal();
    },
    data () {
        return {
            isFullscreen: false,
            optionsUnidade: [],
            optionsBModal: [],
            loading: false,
            isDisabled: false,
          helpForm: new Form({statusRecord: [], params: []}),
          form: new Form({
              num_fiscal: '',
              chave: '',
              dt_inicio: '',
              dt_fim: '',
              unidade: [],
              b_modal: []
           }),
       }
    },
    methods: {
        doGerar() {
            this.loading = true;
            this.isDisabled = true;
            this.dt_inicio_label = this.dt_inicio;
            this.dt_fim_label = this.dt_fim;
            this.form.post('/api/synchro/integrar').then(response =>
            {
                new ReturnApi(response, this)
                this.dt_inicio = this.dt_inicio_label;
                this.dt_fim = this.dt_fim_label;
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
                this.dt_inicio = this.dt_inicio_label;
                this.dt_fim = this.dt_fim_label;
            });
        },
        getUnidade() {
            this.helpForm.params = { tabela: 'unidade',
                                    coluna: 'descr' };

            this.helpForm.get('/api/unidade/jsonlist').then(response =>
            {
                new ReturnApi(response, this, true, false, false);
                response.items.forEach((obj)=>
                {
                    this.optionsUnidade.push({ label: obj.cd, value: obj.unidade_id })
                })
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        getBModal() {
            this.helpForm.params = { tabela: 'b_modal',
                                    coluna: 'descr' };

            this.helpForm.get('/api/bmodal/jsonlist').then(response =>
            {
                new ReturnApi(response, this, true, false, false);
                response.items.forEach((obj)=>
                {
                    this.optionsBModal.push({ label: obj.descr, value: obj.bmodal_id })
                })
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        getPermission(checkPermission) {
            //return true;
            return this.getPermissionFw(checkPermission);
        },
    },
    computed: {
        isLoaded: {
            get() {
                return this.$store.getters.isloaded;
            }
        }
    }
}
</script>
